/**
 *
 * @param {Object} location
 * @param {Boolean} full
 * @return {String}
 */
const renderAddress = (location, full = true) => {
  const street = location.street || '';
  const houseNumber = location.house_number || '';
  const addition = location.addition || '';

  if (!full) {
    return `${street || ''} ${houseNumber || ''}${addition || ''}`;
  }

  return `${street || ''} ${houseNumber || ''}${addition || ''}, ${location.zip_code || ''} ${location.city || ''}`;
};

export default renderAddress;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/renderAddress.js